import { Filter } from '../../models/filters'
import { FiltersApi } from '../../api/filtersApi'

export enum FiltersActions {
    SET_FILTERS_LIST = 'setFiltersList',
    SET_ACTIVE_FILTER = 'setActiveFilter',
}

export const setFiltersList = (value: Filter[]) => {
    return { type: FiltersActions.SET_FILTERS_LIST, value }
}

export const setActiveFilter = (value: boolean) => {
    return { type: FiltersActions.SET_ACTIVE_FILTER, value }
}

export const loadFilterList = (isInitSession?: boolean) => {
    return async (dispatch: any, getState) => {
        FiltersApi.getFiltersList(isInitSession).then((res) => {
            if (res?.data?.filters) {
                let isFilterApplied = false
                res.data.filters.forEach((f: Filter) => {
                    if (f.isApply) isFilterApplied = true
                })
                dispatch(setFiltersList(res.data.filters))
                dispatch(setActiveFilter(isFilterApplied))
            }
        })
    }
}
